import { render } from "./VStep.vue?vue&type=template&id=f096434a&scoped=true"
import script from "./VStep.vue?vue&type=script&lang=js"
export * from "./VStep.vue?vue&type=script&lang=js"

import "./VStep.vue?vue&type=style&index=0&id=f096434a&lang=scss&scoped=true"

import exportComponent from "/opt/atlassian/pipelines/agent/build/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f096434a"],['__file',"src/components/tour/VStep.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f096434a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f096434a', __exports__)) {
    api.reload('f096434a', __exports__)
  }
  
  module.hot.accept("./VStep.vue?vue&type=template&id=f096434a&scoped=true", () => {
    api.rerender('f096434a', render)
  })

}


export default __exports__